import { Quotes } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import Stars from "@/components/Stars";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section className="bg-brand-coal py-24 md:py-32" data-testid="testimonials">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="mb-14 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Avaliações</p>
            <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
              Quem já foi atendido
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <span className="font-display text-6xl text-brand-red">5.0</span>
            <div>
              <Stars />
              <p className="mt-1 text-xs uppercase tracking-wide text-white/50">Nota máxima dos clientes</p>
            </div>
          </div>
        </Reveal>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 4) * 0.05}>
              <figure className="flex h-full flex-col justify-between rounded-sm border border-white/10 bg-brand-obsidian p-6 transition-colors duration-300 hover:border-brand-red">
                <div>
                  <Quotes weight="fill" className="h-7 w-7 text-brand-red/60" />
                  <Stars className="mt-3" />
                  <blockquote className="mt-4 text-sm leading-relaxed text-white/70">&ldquo;{t.text}&rdquo;</blockquote>
                </div>
                <figcaption className="mt-6 border-t border-white/10 pt-4">
                  <p className="font-heading text-sm font-semibold uppercase tracking-wide text-white">{t.name}</p>
                  <p className="font-mono text-xs text-brand-red">{t.city}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
